import styled from 'styled-components';
import { rem } from 'polished';
import variables from '@styles/variables';
import HighlightText from '@atoms/HighlightText/HighlightText';
import Text from '@atoms/Text/Text';
import type { Suggestion } from '@occ/api-client';

interface Props {
  suggestion: Suggestion;
  searchTerm: string;
  listComponentOnClick: (suggestion: Suggestion) => void;
}

const StyledFullAddressListItem = styled.div`
  padding: ${rem(17)} ${rem(28)} ${rem(17)} ${rem(16)};
  margin: 0 ${rem(-16)};

  flex: 1;
  font-family: ${variables.fonts.fontGothamBook};
  font-size: ${rem(15)};
  line-height: ${rem(24)};
`;

const StyledFullAddressListItemHead = styled.div`
  font-family: ${variables.fonts.fontGothamMedium};
`;

const FullAddressListItem = ({ suggestion, searchTerm, listComponentOnClick }: Props) => {
  const { street, street_number, letter, postalcode, locality } = suggestion;
  return (
    <StyledFullAddressListItem
      data-testid="full-address-list-item"
      onClick={() => listComponentOnClick({ street, street_number, letter, locality, postalcode })}
    >
      <StyledFullAddressListItemHead>
        <HighlightText text={`${street} ${street_number}${letter} `} term={searchTerm} />
      </StyledFullAddressListItemHead>
      <Text type="body" size="small">
        <HighlightText text={`${postalcode} `} term={searchTerm} />
        <HighlightText text={`${locality}`} term={searchTerm} />
      </Text>
    </StyledFullAddressListItem>
  );
};

export default FullAddressListItem;
